(() => {
  const states = new Map();
  const rootFor = element => element.closest('product-info');
  const rootKey = root => root.dataset.productId || root.id;
  const stateFor = root => {
    const key = rootKey(root);
    if (!states.has(key)) states.set(key, { chosen: new URL(location.href).searchParams.has('variant') });
    return states.get(key);
  };
  const chosenSize = root => root.querySelector('variant-selects input[type="radio"]:checked')?.value;
  const configure = root => {
    const picker = root.querySelector('variant-selects');
    if (!picker) return;
    const state = stateFor(root);
    const button = root.querySelector('button[name="add"]');
    if (!state.chosen) {
      picker.querySelectorAll('input[type="radio"]:checked').forEach(input => { input.checked = false; });
      if (button && !button.disabled) button.disabled = true;
    }
    if (button && root.id.startsWith('MainProduct-')) {
      let bar = root.querySelector('.neechy-mobile-buy');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'neechy-mobile-buy';
        const action = document.createElement('button');
        action.type = 'button';
        action.className = 'button button--full-width';
        action.addEventListener('click', () => {
          const currentButton = root.querySelector('button[name="add"]');
          if (!stateFor(root).chosen) {
            root.querySelector('variant-selects')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            root.querySelector('variant-selects input, variant-selects select')?.focus({ preventScroll: true });
          } else if (currentButton && !currentButton.disabled) currentButton.click();
        });
        bar.append(action);
        root.append(bar);
        new IntersectionObserver(entries => {
          bar.classList.toggle('neechy-mobile-buy--visible', !entries[0].isIntersecting);
        }, { threshold: 0.2 }).observe(root.querySelector('product-form') || button);
      }
      const action = bar.querySelector('button');
      const chooseLabel = picker.querySelector('.nc-size-legend > span')?.textContent.trim() || Array.from(picker.querySelector('legend')?.childNodes || [])
        .find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim())?.textContent.trim();
      const label = state.chosen ? button.textContent.trim() : (chooseLabel || button.textContent.trim());
      if (action.textContent !== label) action.textContent = label;
      const disabled = state.chosen && button.disabled;
      if (action.disabled !== disabled) action.disabled = disabled;
    }
  };
  const configureAll = () => document.querySelectorAll('product-info').forEach(configure);
  document.addEventListener('change', event => {
    if (!event.target.matches('variant-selects input[type="radio"], variant-selects select')) return;
    const root = rootFor(event.target);
    if (root) stateFor(root).chosen = true;
  }, true);
  document.addEventListener('submit', event => {
    const root = rootFor(event.target);
    if (!root?.querySelector('variant-selects') || stateFor(root).chosen) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    root.querySelector('variant-selects')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    root.querySelector('variant-selects input, variant-selects select')?.focus();
  }, true);
  document.addEventListener('click', event => {
    const guideLink = event.target.closest('a[href="#size-guide"]');
    if (guideLink) {
      const guide = document.getElementById('size-guide');
      if (guide) guide.open = true;
    }
    const link = event.target.closest('[data-neechy-pack]');
    if (!link) return;
    const root = rootFor(link);
    if (!root || !stateFor(root).chosen) return;
    const size = chosenSize(root);
    if (!size) return;
    try {
      const variants = JSON.parse(link.dataset.neechyVariants);
      const matching = variants.find(variant => variant.available && variant.options.includes(size));
      if (!matching) return;
      const url = new URL(link.href);
      url.searchParams.set('variant', matching.id);
      link.href = url.toString();
    } catch {}
  }, true);
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; configureAll(); });
  });
  const boot = () => {
    configureAll();
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('product-info:loaded', configureAll);
    document.addEventListener('shopify:section:load', configureAll);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
